import { render, staticRenderFns } from "./PageEditor.vue?vue&type=template&id=5d146edd&scoped=true&lang=pug&"
import script from "./PageEditor.vue?vue&type=script&lang=js&"
export * from "./PageEditor.vue?vue&type=script&lang=js&"
import style0 from "./PageEditor.vue?vue&type=style&index=0&id=5d146edd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d146edd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
